import { Input } from 'antd';
import { inject, observer } from 'mobx-react';
import { Display } from '@/components/Display/Display';
import GrtTextArea from '@/components/Web/GrtTextArea';
import s from './style.module.scss';
const ShortAnswer = (props) => {
    const { simulation } = props.store;
    let { curUserAnswer, setCurUserAnswer, loading } = simulation;
    const onChange = (e) => {
        if (loading) {
            return;
        }
        setCurUserAnswer({
            custom_value: e.target.value
        });
    };
    return (
        <>
            <div className={s['custom-input']}>
                <div>
                    <GrtTextArea
                        value={curUserAnswer?.custom_value}
                        onChange={onChange}
                        autoSize={{ minRows: 15, maxRows: 15 }}
                        style={{ resize: 'none' }}
                        placeholder="请输入"
                        maxLength={2000}
                        showCount
                    />
                </div>
                <Display show={true}>
                    <div className={s['custom-input-err-tip']}>
                        {!curUserAnswer?.custom_value || curUserAnswer?.custom_value.trim() === '' ? '内容不能为空' : ''}
                    </div>
                </Display>
            </div>
        </>
    );
};
export default inject('store')(observer(ShortAnswer));
